import { render, staticRenderFns } from "./addStore.vue?vue&type=template&id=132cba1b&scoped=true"
import script from "./addStore.vue?vue&type=script&lang=js"
export * from "./addStore.vue?vue&type=script&lang=js"
import style0 from "./addStore.vue?vue&type=style&index=0&id=132cba1b&prod&lang=css"
import style1 from "./addStore.vue?vue&type=style&index=1&id=132cba1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132cba1b",
  null
  
)

export default component.exports